export default __webpack_public_path__ + "static/media/img-placeholder.1ab2939a.png";